import React, { Fragment, useState } from 'react';
import classnames from 'classnames';
import styled from 'styled-components';
export const Preloader = (props) => {
    const { isLoading, children, loader } = props;
    const [transitionEnd, setTransitionEnd] = useState(false);
    const containerClasses = classnames('preloader', {
        ['active']: isLoading,
        ['displayNone']: transitionEnd,
    });
    return (React.createElement(Fragment, null,
        React.createElement(PreloaderContainer, { onTransitionEnd: () => setTransitionEnd(true), className: containerClasses }, loader || (React.createElement("div", { className: 'message' },
            React.createElement("svg", { "aria-hidden": "true", focusable: "false", "data-prefix": "fas", "data-icon": "spinner", role: "img", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", className: 'spinner' },
                React.createElement("path", { className: 'spinning', fill: "currentColor", d: "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z" })),
            "Loading data..."))),
        children));
};
const PreloaderContainer = styled.div `
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: space-around;
  background: white;
  z-index: 999999;
  pointer-events: none;
  opacity: 0;
  transition: all 300ms;

  &.displayNone {
    display: none;
  }

  &.active {
    opacity: 1;
    pointer-events: all;
  }

  .message {
    font-size: emy(16);
  }

  .spinner {
    width: 16px;
    margin-right: 5px;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(355deg);
    }
  }

  .spinning {
    animation-duration: 2s;
    animation-name: spin;
    animation-iteration-count: infinite;
    transform-origin: 50% 50%;
    animation-timing-function: linear;
  }
`;
